import ShipmentDocumentations from './shipment-documentations';

export default ShipmentDocumentations;